import { render } from "./EPortfolioProject.vue?vue&type=template&id=3ae591a8&scoped=true"
import script from "./EPortfolioProject.vue?vue&type=script&lang=js"
export * from "./EPortfolioProject.vue?vue&type=script&lang=js"

import "./EPortfolioProject.vue?vue&type=style&index=0&id=3ae591a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae591a8"]])

export default __exports__